export default {
  reportError (arg) {
    console.log(arg)
  }
}
